module.exports = __webpack_public_path__ + "img/136ne.4e14ca14.svg";